<template>
  <v-overlay :z-index="9999" scrim="neutral0" :opacity="1" :model-value="true">
    <v-container fill-height height="100%">
      <v-row align="center" justify="center" height="100%">
        <template v-if="userId">
          <v-col cols="12" class="text-center">
            <BrandButton
              size="large" variant="primary" min-width="220"
              @click="onBookmark"
            >
              {{ t('cta.bookmark_this_page') }}
            </BrandButton>
          </v-col>
          <v-col cols="12" class="text-center">
            <BrandButton
              size="large" variant="secondary" min-width="220"
              target="_blank" :href="extAppUrl"
            >
              {{ t('cta.open_rubra') }}
            </BrandButton>
          </v-col>
        </template>
        <template v-else>
          <!-- Removed due to Apple policies -->
          <!--
          <v-col cols="12" class="text-center">
            <BrandButton
              size="large" variant="secondary" min-width="220"
              target="_blank"
              :href="extAppUrl"
            >
              {{ t('cta.social_login') }}
            </BrandButton>
          </v-col>
          -->
          <v-col cols="12" class="text-center">
            <BrandButton
              size="large" variant="primary" min-width="220"
              :href="extAppUrl"
            >
              {{ t('cta.sign_up') }}
            </BrandButton>
          </v-col>
          <v-col cols="12" class="text-center">
            <BrandButton
              size="large" variant="secondary" min-width="220"
              :href="extAppUrl"
            >
              {{ t('cta.login') }}
            </BrandButton>
          </v-col>
        </template>
      </v-row>
    </v-container>
  </v-overlay>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import BrandButton from '@/components/global/brand/BrandButton.vue'

// Setup composables
const store = useStore()
const { t } = useI18n()

// Browser reference
const browser = ref(null)
const extAppUrl = ref('')

// Initialize browser if in extension mode
onMounted(async () => {
  if (BUILD_TARGET === 'extension') {
    const browserModule = await import('webextension-polyfill')
    browser.value = browserModule.default
    extAppUrl.value = browser.value.runtime.getURL('index.html')
  }
})

// Store getters
const userId = computed(() => store.getters['auth/userId'])

// Methods
const onBookmark = () => {
  if (browser.value) {
    browser.value.runtime.sendMessage({ event: 'background:bookmark-page' })
    window.close()
  }
}
</script>
